import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: "app-modal-default",
	templateUrl: "./modal-default.component.html",
	styleUrls: ["./modal-default.component.scss"]
})
export class ModalDefaultComponent implements OnInit {
	public modal: any;
	constructor(
		public dialogRef: MatDialogRef<ModalDefaultComponent>,
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
	}

	closeDialog() {
		this.dialogRef.close();
	}

}
